import * as React from 'react';

import {FieldArray} from 'redux-form';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {TagType} from 'nutshell-graphql-types';

import {TagSelect} from './tag-select';

type Props = {
    tagType: TagType;
    shouldAnd?: boolean;
};

export function AddTagForm(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body>Which tag?</Body>
            <FieldArray
                name='tags'
                component={TagSelect}
                tagType={props.tagType}
                shouldAnd={props.shouldAnd}
            />
        </StackLegacy>
    );
}
